import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function IGGIgmForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    typhiDotIgm: "",
    typhiDotIgg: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>IGG - IGM TEST FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">TEST REPORT</h5>
        <div className="mb-2">
          <label>TYPHI DOT / SALMONELLA TYPHI IgM (ICT):</label>
          <input
            type="text"
            className="form-control"
            name="typhiDotIgm"
            value={form.typhiDotIgm}
            onChange={handleChange}
          />
        </div>

        <div className="mb-2">
          <label>TYPHI DOT / SALMONELLA TYPHI IgG:</label>
          <input
            type="text"
            className="form-control"
            name="typhiDotIgg"
            value={form.typhiDotIgg}
            onChange={handleChange}
          />
        </div>

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          IGG - IGM TEST REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">TEST REPORT</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>TYPHI DOT / SALMONELLA TYPHI IgM (ICT)</td>
              <td>{form.typhiDotIgm}</td>
            </tr>
            <tr>
              <td>TYPHI DOT / SALMONELLA TYPHI IgG</td>
              <td>{form.typhiDotIgg}</td>
            </tr>
          </tbody>
        </table>

        <p className="mt-3">
          <strong>NOTE:</strong>
          <br />
          1. Low titre of IgM antibodies to S. typhi may persist for about 4
          months post-infection in endemic areas.
          <br />
          2. All results to be clinically correlated.
        </p>

        <p className="mt-3">
          <strong>Comments:</strong> <br />
          Typhi dot is a rapid test for detection of IgM antibodies to
          Salmonella Typhi. Accurate diagnosis of typhoid fever at an early
          stage is important for etiological diagnosis, to identify and treat
          potential carriers and prevent acute typhoid fever outbreaks.
          <br />
          The conventional Widal test detects antibodies to S. typhi from the
          second week of onset of symptoms whereas early rising antibodies
          predominantly IgM in nature detected by typhi dot serve as a marker
          for recent infection.
        </p>

        <h6 className="mt-3">Detectable IgM response:</h6>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Onset of fever</th>
              <th>Percent positive</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>4-6 days</td>
              <td>43.5%</td>
            </tr>
            <tr>
              <td>6-9 days</td>
              <td>92.9%</td>
            </tr>
            <tr>
              <td>&gt;9 days</td>
              <td>99.5%</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default IGGIgmForm;
